import React from 'react';

import QuotaSede  from 'components/Tvendo/Sale/QuotaBPartner/Clorox/QuotaSedeClorox/List.js';

export default function () {
  return <QuotaSede  />;
}